module.exports = __webpack_public_path__ + "img/bloodelf_war_academy_small.af631850.png";